import { useState } from "react";

// OpenLayers
import OlMap from "ol/Map";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import WKT from "ol/format/WKT";

// Tools
import { getLocationAndSiteFeatures, zoomToExtent } from "lib/utilities/map";
import { assetURL } from "lib/utilities/asset";

import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

import "styles/css/LocationsPopup.scss";

const LocationsPopup = new Popup({
	title: () => getLocaleString("locations"),
	style: {height: 500, width: "100%", maxWidth: 400},
	styleContainer: {overflow: "hidden"},
	render: function() {
		const map:OlMap = this.get("map");
		const features:Feature<Geometry>[] = getLocationAndSiteFeatures(map);
			
		const [searchLocation, setSearchLocation] = useState<string>("");
			
		const selectFeature = (feature:Feature<Geometry>) => {
			zoomToExtent(feature.getGeometry().getExtent(), 0, map);
			_ui.closePopupOf(this);
		}
		const drawOptions = () => {
			const rows:Array<any> = [];
			
			// Sort alphabetically the location names
			features.sort((a:Feature<Geometry>, b:Feature<Geometry>) => a.get("name").localeCompare(b.get("name")));
			
			features.forEach((feature:Feature<Geometry>) => {
				const name:string = feature.get("name");
				const search:string = searchLocation;
				
				if(search) {
					if(!name.toLowerCase().includes(search.toLowerCase())) 
						return;
				}
				
				rows.push(
					<div 
						className="unit-option" 
						key={features.indexOf(feature)} 
						onClick={() => selectFeature(feature)}
					>
						<img src={assetURL(`assets/images/pin.png`)} />
						{name}
					</div>
				);
			});
			
			if(rows.length < 1) {
				return (
					<div className="locs-container__none">
						No results found
					</div>
				)
			}
			
			return rows;
		}
		
		return (
			<div className="locs-container">
				<div className="locs-container__search">
					<input 
						type="search" 
						placeholder={getLocaleString("searchlocs")}
						onChange={(e) => setSearchLocation(e.target.value)} 
						value={searchLocation}
						autoComplete="off"
						style={{width: "100%"}}
					/>
				</div>
				<div className="locs-container__list">
					{drawOptions()}
				</div>
			</div>
		)
	}
});

export default LocationsPopup;